import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export default function OAuthSuccess() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    try {
      // 1. Get token from URL fragment (#token=...)
      const hash = window.location.hash; // "#token=eyJ..."
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get("token");

      if (!token) {
        throw new Error("No token found in URL");
      }
      login(token);

      // 5. Clean URL (remove token from address bar)
      window.history.replaceState({}, document.title, window.location.pathname);

      // 6. Redirect to home
      navigate("/", { replace: true });
    } catch (err) {
      console.error("OAuth success handling failed:", err);
      navigate("/oauth-error", { replace: true });
    }
  }, [navigate, login]);

  return null;
}
